import React from "react";
import { SiteLayout } from "../components/SiteLayout";

export interface ToolsLayoutProps {
  children: React.ReactNode;
}

export function ToolsLayout({ children }: ToolsLayoutProps) {
  return <SiteLayout>{children}</SiteLayout>;
}
